import types from '../state/types';
var PresenceActions = /** @class */ (function () {
    function PresenceActions() {
    }
    PresenceActions.prototype.action$updatePresence = function (data) {
        return {
            type: types.UPDATE_PRESENCE,
            meta: {
                data: data,
            },
        };
    };
    PresenceActions.prototype.action$clearStalePresenceSessions = function () {
        return {
            type: types.PRESENCE_CLEAR_STALE,
        };
    };
    PresenceActions.prototype.action$clearPresence = function () {
        return {
            type: types.CLEAR_PRESENCE,
        };
    };
    PresenceActions.prototype.action$fetchPresence = function (preFetchPresence) {
        return {
            type: types.FETCH_PRESENCE,
            payload: preFetchPresence,
        };
    };
    PresenceActions.prototype.action$fetchListPresence = function (preFetchPresenceList) {
        return {
            type: types.FETCH_VISITORS_PRESENCE,
            payload: preFetchPresenceList,
        };
    };
    return PresenceActions;
}());
export { PresenceActions };
export default new PresenceActions();
